import { CONSTANTS } from "@/config/constants";
import { useAppTheme } from "@/hooks/use-app-theme";

type Logos = {
  full: string;
  icon: string;
};

export const useLogo = (): Logos => {
  const theme = useAppTheme();
  const isLight = theme === "light";

  return {
    full:
      isLight && CONSTANTS.LOGO_FULL_LIGHT
        ? CONSTANTS.LOGO_FULL_LIGHT
        : CONSTANTS.LOGO_FULL,
    icon: CONSTANTS.LOGO_ICON,
  };
};
